module.exports = __webpack_public_path__ + "static/media/tv.f80796c4.svg";